module.exports.rootElement = { id: 'root', selector: '#root' };
